// WARNING: This file is for internal use only by AuthManager.server.ts and AuthManager.client.ts.
// Do NOT import or use this file directly elsewhere in your codebase.

import {
  User,
  SupabaseClient,
  AuthResponse,
  AuthError,
} from "@supabase/supabase-js";

export async function getCurrentUser(
  authClient: SupabaseClient
): Promise<User | null> {
  const {
    data: { user },
    error,
  } = await authClient.auth.getUser();

  if (error || !user?.id) {
    return null;
  }

  return user;
}

export async function requireCurrentUser(
  client: SupabaseClient
): Promise<User> {
  const user = await getCurrentUser(client);

  if (!user) {
    throw new Error("Unauthorized - User not authenticated");
  }

  return user;
}

export async function updateUser(
  client: SupabaseClient,
  userId: string,
  updates: Record<string, any>
): Promise<{ data: { user: User | null } | null; error: AuthError | null }> {
  return client.auth.admin.updateUserById(userId, updates);
}

export async function setPassword(
  client: SupabaseClient,
  userId: string,
  newPassword: string
): Promise<{ data: { user: User | null } | null; error: AuthError | null }> {
  return client.auth.admin.updateUserById(userId, { password: newPassword });
}
